var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DetailArticle',{attrs:{"item":_vm.news.data,"schemaType":"NewsArticle"}})
}
var staticRenderFns = []

export { render, staticRenderFns }